import { i18nMark } from 'lingui-react';

const formattedMessages = {
  title: i18nMark('#{caseId}'),
  complaintTitle: i18nMark('Complaint'),
  created: i18nMark('Created'),
  estimate: i18nMark('Estimate'),
  etr: i18nMark('ETR'),
  status: i18nMark('Status'),
  statusPopoverCaseStatus: i18nMark('Case Status'),
  statusPopoverRepairStatus: i18nMark('Repair Status'),
  statusPopoverTitle: i18nMark('Status'),
  undefinedServiceProvider: i18nMark('Service Provider'),
  unit: i18nMark('Unit'),
  vin: i18nMark('VIN'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./components/CaseDisplayElement/messages.js